<template>
  <v-dialog v-model="showDialog" persistent max-width="800">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        color="primary"
      >
        ADICIONAR TAREFA
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title">Adicionar Tarefa</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="showDialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            md="9"
            sm="9"
            lg="9"
          >
            <v-combobox
              v-model="payload.solucoesEvento"
              :items="solucoes"
              chips
              clearable
              label="Soluções"
              item-text="nome"
              item-value="municipioSolucaoId"
              multiple
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip
                  close
                  @click:close="removeSolucao(item)"
                >
                  <strong>{{ item.nome }}</strong>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
          <v-col
            md="3"
            sm="3"
            lg="3"
          >
            <v-btn
              outlined
              color="primary"
              class="ml-3"
              @click="getTasks()"
              v-if="payload.solucoesEvento.length > 0"
            >
              BUSCAR TAREFAS
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            md="9"
            sm="9"
            lg="9"
          >
            <v-combobox
              v-model="payload.tarefasEvento"
              :items="tarefas"
              chips
              clearable
              label="Tarefas"
              item-text="nome"
              item-value="municipioTarefaId"
              multiple
            >
              <template v-slot:selection="{ attrs, item }">
                <v-chip
                  close
                  @click:close="removeTarefa(item)"
                >
                  <strong>{{ item.nome }}</strong>
                </v-chip>
              </template>
            </v-combobox>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="showDialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="save()">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { citySolutionAPI } from '@/modules/city/API/CitySolutionAPI'
import { cityTaskAPI } from '@/modules/city/API/CityTaskAPI'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppModalInsertMeeting',
  props: {
    dialog: { type: Boolean, default: false }
  },
  data () {
    return {
      payload: {
        municipioId: this.$route.params.id,
        solucoesEvento: [],
        tarefasEvento: []
      },
      solucoes: [],
      tarefas: [],
      showDialog: this.dialog,
      municipio: {
        projetoId: 1
      },
      arrayTarefas: []
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    getSolutions () {
      this.setLoading(true)
      citySolutionAPI.getByCity(this.payload.municipioId)
        .then(resp => {
          this.solucoes = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter soluções')
        })
    },
    getTasks () {
      this.setLoading(true)
      cityTaskAPI.getTasks(this.payload.solucoesEvento.map(function (item) { return item.municipioSolucaoId }))
        .then(resp => {
          this.tarefas = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter tarefas')
        })
    },
    removeSolucao (item) {
      this.payload.solucoesEvento.splice(this.payload.solucoesEvento.indexOf(item), 1)
      this.payload.solucoesEvento = [...this.payload.solucoesEvento]
      this.tarefas = []
      this.chipsTarefas = []
    },
    removeTarefa (item) {
      this.payload.tarefasEvento.splice(this.payload.tarefasEvento.indexOf(item), 1)
      this.payload.tarefasEvento = [...this.payload.tarefasEvento]
    },
    save () {
      this.showDialog = false
      this.$emit('onAddTask', this.payload.tarefasEvento)
    }
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  created () {
    this.getSolutions()
  }
}
</script>
